import React from 'react';
import { Chip, Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { usePagedList } from '../../../hooks/use-paged-list';
import { useGovernmentProjectSearchController } from './context/government-project-search-controller';
import { useGovernmentProjectSearchState } from './context/government-project-search-context';
import GovernmentProjectAppService from '../../../application/platform/apm/government-project/government-project-app-service';
import { TIPO_PROJETO_GOVERNAMENTAL_LABEL, TipoProjetoGovernamental, enumOptions } from '../../../model/apm/apm-enums';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { PagedGrid } from '../../../components/paged-grid';
import { DeleteAction, EditAction, OpenLinkAction } from '../../../components/row-actions';
import { GovernmentProjectDrawer } from './components/government-project-drawer';

export function GovernmentProjectSearchComponent() {
    const ctrl = useGovernmentProjectSearchController();
    const { parameters, searchTrigger, drawer } = useGovernmentProjectSearchState();
    const list = usePagedList(GovernmentProjectAppService.list, parameters, searchTrigger, 'Não foi possível carregar os projetos');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        {
            field: 'type', headerName: 'Tipo', width: 120,
            renderCell: (params) => <Chip size="small" color="primary" variant="outlined" label={TIPO_PROJETO_GOVERNAMENTAL_LABEL[params.value as TipoProjetoGovernamental] || '-'} />
        },
        { field: 'name', headerName: 'Nome', flex: 1, minWidth: 240 },
        { field: 'responsibleName', headerName: 'Responsável', width: 220 },
        { field: 'results', headerName: 'Resultados', flex: 1, minWidth: 200, sortable: false },
        {
            field: 'actions', headerName: 'Ações', width: 130, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    {params.row.link && <OpenLinkAction url={params.row.link} />}
                    <EditAction onClick={() => ctrl.openDrawer(params.row)} />
                    <DeleteAction onClick={() => ctrl.handleDelete(params.row)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Projetos de Governo"
                    subtitle="Projetos, atividades, ações e programas divulgados no portal"
                    breadcrumbs={[{ label: 'Projetos de Governo' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={8}>
                        <FilterInput label="Nome ou responsável" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FilterSelect label="Tipo" name="select-type" value={parameters.type} options={enumOptions(TIPO_PROJETO_GOVERNAMENTAL_LABEL)} onChange={ctrl.handleOnChange} />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <PagedGrid
                    columns={columns}
                    list={list}
                    parameters={parameters}
                    onPaginationChange={ctrl.handlePaginationChange}
                    addLabel="Novo Projeto"
                    onAdd={() => ctrl.openDrawer()}
                />
            </Grid>

            <GovernmentProjectDrawer
                open={drawer.open}
                initial={drawer.project}
                isSaving={ctrl.isSaving}
                onClose={ctrl.closeDrawer}
                onSave={ctrl.handleSave}
            />
        </React.Fragment>
    );
}
